// extracted by mini-css-extract-plugin
export default {"addToCartMobile":"productDetails_addToCartMobile__JZQ0D"};